import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";

export default function OrderDashboard() {

  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {

    loadStats();

  }, []);


  const loadStats = async () => {

    try {

      const res = await axiosInstance.get(
        "/dashboard/order-stats/"
      );

      setStats(res.data);

    } catch (err) {

      alert("Failed to load dashboard ❌");

    } finally {

      setLoading(false);

    }
  };


  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading...</p>;
  }


  return (

    <div style={container}>


      <h1>📊 Order Dashboard</h1>


      <div style={grid}>


       <Card
  title="Pending Orders"
  count={stats.pending}
  color="#facc15"
  status="pending"
/>

<Card
  title="Completed Orders"
  count={stats.completed}
  color="#22c55e"
  status="completed"
/>

<Card
  title="Rejected Orders"
  count={stats.rejected}
  color="#ef4444"
  status="rejected"
/>

<Card
  title="Approved Delivery"
  count={stats.approved_delivery}
  color="#3b82f6"
  status="delivery"
/>

<Card
  title="Store Pickup"
  count={stats.store_pickup}
  color="#10b981"
  status="pickup"
/>


      </div>

    </div>
  );
}



/* ---------------- CARD ---------------- */
function Card({ title, count, color, status }) {

  const navigate = useNavigate();

  return (

    <div
      style={{ ...card, borderColor: color, cursor: "pointer" }}

      onClick={() => navigate(`/dashboard/orders/${status}`)}
    >

      <h3>{title}</h3>

      <h1 style={{ color }}>
        {count}
      </h1>

      <p style={{ fontSize: 12 }}>
        Click to view →
      </p>

    </div>
  );
}



/* ---------------- STYLES ---------------- */

const container = {
  maxWidth: 900,
  margin: "auto",
  padding: 30,
  textAlign: "center"
};


const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  gap: 20,
  marginTop: 30
};


const card = {
  background: "#fff",
  padding: 25,
  borderRadius: 12,
  border: "3px solid",
  boxShadow: "0 4px 8px rgba(0,0,0,0.05)"
};
